import { httpClient } from '../../../httpClient';

const url = process.env.REACT_APP_CLINICIAN_PROFILE_SERVICE_URL;

export const putClientInvoiceSettings = (token: string, _id: string, values: Record<string, any>) =>
  httpClient('PUT', url!, 204, { Authorization: `Bearer ${token}` })(
    `/clinicians/me/client-records/${_id}/invoice-settings`,
    values
  );
